import { useEffect, useState } from "react";

import { useParams } from "react-router-dom";

import { getHiddenMentions, markRelevant } from "@/api/endpoints/searches";
import Spinner from "@/components/Spinner";
import { useMessages } from "@/containers/Messages/MessageContext";
import MentionRow from "@/views/MentionSettingsView/partials/HiddenMentions/MentionRow";
import AllEarsTitle from "@components/AllEarsTitle";
import Pagination from "@components/Pagination";

import { preprocess } from "./utils";

import styles from "./HiddenMention.module.css";

const HiddenMentions = () => {
  const [mentions, setMentions] = useState([]);
  const [meta, setMeta] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const { uuid } = useParams();
  const { danger, success } = useMessages();

  const handleMarkRelevant = (public_id) => {
    return markRelevant([public_id])
      .then(() => {
        // Set the irreleveant
        setMentions((current) =>
          current.filter((m) => m.public_id !== public_id)
        );
        success({
          title: L.MENTIONS_VIEW_UNHIDDEN_ACTION,
          message: "",
        });
      })
      .catch((error) => {
        danger({
          title: L.CUSTOMERS_SEARCH_500_ERROR_TITLE,
          message: L.CUSTOMERS_SEARCH_500_ERROR_MESSAGE,
        });

        throw error;
      });
  };

  useEffect(() => {
    setLoading(true);
    getHiddenMentions(uuid, { p: currentPage })
      .then(({ data }) => {
        setMentions(preprocess(data.mentions));
        setMeta(data.meta);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        throw error;
      });
  }, [uuid, currentPage]);

  return (
    <>
      <AllEarsTitle>{L.MENTIONS_VIEW_HIDDEN_HEADER}</AllEarsTitle>

      <div className="pb-3">
        {loading ? (
          <div className="flex w-full justify-center">
            <Spinner className="flex self-center mb-5" />
          </div>
        ) : mentions?.length ? (
          <div>
            {mentions.map((mention) => (
              <MentionRow
                className={styles.mention}
                mention={mention}
                key={mention.public_id}
                onMarkRelevant={handleMarkRelevant}
              />
            ))}
          </div>
        ) : (
          <p data-testid="hidden-mentions-no-hits">{L.MENTIONS_VIEW_NO_HITS}</p>
        )}

        <Pagination
          next={() => setCurrentPage((n) => n + 1)}
          previous={() => setCurrentPage((n) => n - 1)}
          current={currentPage}
          max={meta?.page_count}
        />
      </div>
    </>
  );
};

export default HiddenMentions;
